export default "__VITE_ASSET__NtDPB4sj__"